import { render, staticRenderFns } from "./ProductSidebar.vue?vue&type=template&id=6146fc02&scoped=true&"
import script from "./ProductSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProductSidebar.vue?vue&type=style&index=0&id=6146fc02&prod&scoped=true&lang=css&"
import style1 from "./ProductSidebar.vue?vue&type=style&index=1&id=6146fc02&prod&lang=scss&"
import style2 from "./ProductSidebar.vue?vue&type=style&index=2&id=6146fc02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6146fc02",
  null
  
)

export default component.exports